<cal-add-delivery-route [editItem]="editItem"></cal-add-delivery-route>
<div class="panel" style="margin-top: 5px;">
   <div class="panel-body">
      <cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="dataList | async" (sortTriggered)="onSort($event)"
         (filterTriggered)="onFilter($event)" (clearFilterAndSortingTriggered)="onClearFilterAndSorting()"
         [isLoading]="isLoading | async" [filterExpression]="filterExpression | async"
         [dataTotalCount]="(dataList | async).length">
      </cal-calsiumlist-listing>
   </div>
</div>